import React, { useState, useEffect } from 'react';
import Link from 'next/link';
import { handleForgotPassword } from "../../../api/auth";
// import "./style.scss"
import { shallowEqual, useSelector} from "react-redux";

function ForgotPassword(props) {

	const [resetForm, setResetForm] = useState({
		email: '',
		emailValid: '',
		loading: false
	});

	const { iskajabiUser } = useSelector((state) => ({
		iskajabiUser: state.userAuth.is_kajabi_user,
	}), shallowEqual);

	useEffect(() => {
		if (Object.keys(resetForm.email).length > 0) {
			validate('email');
		}
	}, [resetForm.email]);

	const updateField = (field, val) => {
		setResetForm({ ...resetForm, [field]: val });
	}

	const validate = (field) => {
		let regex, valid;
		let value = resetForm[field];
		switch (field) {
			case 'email':
				regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
				setResetForm({ ...resetForm, [field + "Valid"]: regex.test(value) });
				break;
		}
	}

	const validateForm = () => {
		const { emailValid } = resetForm;
		return (!!emailValid);
	}

	const resetEmail = () => {
		if (validateForm()) {
			setResetForm({ ...resetForm, loading: true });

			let data = {
				email: resetForm.email,
			}

			handleForgotPassword(data).then((res) => {
				setResetForm({ ...resetForm, loading: false, email: '' });
			});
		}
	}

	return (
		<div className="login-page forgot-page">
			<div className="login-wrapper">
				<div className="box">
				
					<h1>{iskajabiUser ? "Welcome to Bayan Community!" : "Find Your Bayan Account"}</h1>
					<p className="bayan-mb">Enter your email associated with your Bayan Account to receive a one-time temporary link to log into Bayan.</p>
					<div className="inner-box mt-2">
						<div className="field">
							<input id="_email" name="email" type="email" className={"is-input email-field " + (resetForm.emailValid === false ? 'input-err' : resetForm.emailValid === true ? 'input-valid' : '')}
								placeholder="Email" value={resetForm.email} onChange={(e) => updateField('email', e.target.value)} />
							{resetForm.emailValid === false && <small className='err-msg'>*Must enter a valid Email.</small>}
						</div>

						<div className={"login-btn " + ((!validateForm() || resetForm.loading) ? 'disabled' : '')} onClick={() => resetEmail()}>
							Send Link {resetForm.loading && <img src={`/icons/loading.svg`} style={{ height: '25px', marginLeft: '10px' }} />}
						</div>

						<Link href="/login" as="/login">
							<a className="underline">Back to Login</a>
						</Link>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ForgotPassword;
